<template>
  <div class="productionProcess-print">
    <template v-if="isWoollen === true">
      <print-woollen></print-woollen>
    </template>
    <template v-else>
      <div class="productionProcess-print__page page1">
        <print-head :info="info" :is-woollen="isWoollen"></print-head>

        <div class="productionProcess-print__body page1">
          <div class="body-info">
            <div class="body-info__left">
              <div class="body-material-img">
                <div class="body-material-img__title">前后款式图</div>
                <div class="body-material-img__img">
                  <img :src="info.frontBackImg| parseImgUrlToken" alt />
                </div>
              </div>

              <print-cailiao :info="info" :is-woollen="isWoollen"></print-cailiao>
            </div>

            <div class="body-info__right">
              <print-edit :info="info" :is-woollen="isWoollen"></print-edit>

              <print-pieces :info="info" :is-woollen="isWoollen"></print-pieces>
            </div>
          </div>

          <print-size :info="info" :is-woollen="isWoollen"></print-size>
        </div>
      </div>

      <div class="productionProcess-print__page">
        <print-head :info="info" :is-woollen="isWoollen"></print-head>

        <div class="productionProcess-print__body page2">
          <div class="productionProcess-special">
            <div class="productionProcess-special__head">工艺做法</div>
            <div class="productionProcess-special__body">
              <div
                v-for="(item, $index) in info.detailItemList"
                :key="`productionProcess-special__item-${$index}`"
                class="productionProcess-special__item"
              >
                <div class="item-head">部位: {{item.site}}</div>
                <div class="item-img">
                  <img :src="item.imgUrl| parseImgUrlToken" alt />
                </div>
                <div class="item-desc">
                  <p>做法：</p>
                  <p>{{item.methodRemark}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="productionProcess-other">
            <div class="productionProcess-special__head">其他说明</div>
            <table class="productionProcess-other__table">
              <div class="table__head">
                <div>说明类型</div>
                <div>内容</div>
              </div>
              <div class="table__body">
                <div>裁剪说明</div>
                <div>{{info.cuttingDescription}}</div>
              </div>
              <div class="table__body">
                <div>特殊工艺说明</div>
                <div>{{info.specialProcessDescription}}</div>
              </div>
              <div class="table__body">
                <div>缝制说明</div>
                <div>{{info.sewingDescription}}</div>
              </div>
              <div class="table__body">
                <div>样衣数量说明</div>
                <div>{{info.sampleQuantityDescription}}</div>
              </div>
              <div class="table__body">
                <div>整烫说明</div>
                <div>{{info.ironDescription}}</div>
              </div>
              <div class="table__body">
                <div>品质要求说明</div>
                <div>{{info.qualityRequirementsDescription}}</div>
              </div>
            </table>
          </div>

          <div class="productionProcess-teshu">
            <div class="productionProcess-teshu__head">特殊工艺</div>
            <div
              :key="`productionProcess-teshu__body-${$index}`"
              v-for="(item, $index) in info.descriptionList"
              class="productionProcess-teshu__body"
            >
              <div class="teshu-body__left">
                <img :src="item.imgUrl|parseImgUrlToken" alt />
              </div>
              <div class="teshu-body__right">
                <div class="teshu-body__right__head">
                  <div>部位：{{item.usedPosition}}</div>
                  <div>成衣颜色：{{item.codeList|formatCodeList(info.gridCodeList)}}</div>
                </div>
                <div class="teshu-body__right__body">做法：{{item.componentDesc}}</div>
              </div>
            </div>
          </div>

          <div class="body-table__foot">
            <div>复核：</div>
            <div>内检：</div>
            <div>打印日期：</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import printHead from "./modules/print-head.vue";
import printCailiao from "./modules/print-cailiao.vue";
import printPieces from "./modules/print-pieces.vue";
import printSize from "./modules/print-size.vue";
import printEdit from "./modules/print-edit.vue";
import printWoollen from "./modules/is-woollen/index.vue";
import { parseImgUrlToken } from "src/filter/modules/img";
import {
  formatTableHead,
  formatTableCTX
} from "src/pages/components/special-process/modules/mixins";

export default {
  name: "production-process",
  filters: {
    parseImgUrlToken,
    formatCodeList(array, keys) {
      return array
        .reduce((pre, next) => {
          const index = keys.findIndex(inner => inner.colorCode == next);
          if (index > -1) pre.push(keys[index].colorName);
          return pre;
        }, [])
        .join(",");
    },
    filterSizeName(obj) {
      const { sizeCode, sizeName } = obj;
      const str = sizeName.match(/[a-zA-Z]+/);
      if (sizeCode == "pieceSize" || sizeCode == "codeSize") return sizeName;
      if (!str) return sizeName;
      return str[0];
    },
    formatString(str) {
      if (!str) return "";
      return str.replace(/\s*/g, "");
    }
  },
  components: {
    printHead,
    printCailiao,
    printEdit,
    printPieces,
    printSize,
    printWoollen
  },
  computed: {},
  mounted() {
    // document.querySelector('body').classList.add('print_page');
    const { isWoollen } = this.$route.query;
    this.isWoollen = isWoollen == 1;
    this.init();
  },
  data() {
    return {
      info: {},
      isWoollen: false
    };
  },
  methods: {
    init() {
      this.$apis.autoAPi
        .POST_TECHNICS_PRO_DETAIL_GET({
          id: this.$route.query.id,
          materialCode: this.$route.query.materialCode
        })
        .done(res => {
          let productDemandsList = []
          if(res.data.demandList && res.data.demandList.length) {
            let demandList = res.data.demandList.sort((a,b) => a.sizeCode - b.sizeCode)
            let demandGrpup = this.$utils.groupBy(res.data.demandList, item => item.colorCode + '/' + item.colorName) 
            productDemandsList.push([null, ...this.$utils.uniq(demandList.map(item => item.sizeName))])
            this.$utils.forIn(demandGrpup, (value, key) => {
              productDemandsList.push([key, ...value.map(item => item.originQty)])
            })
          }
          res.data.productDemandsList = productDemandsList
          res.data.pattern = res.data.pattern ? res.data.pattern.split(",")
          .map((item) => ({
            comment: item,
            code: item,
          })) : []
          this.info = {
            ...res.data,
            productDemandsListHead: formatTableHead(
              res.data.productDemandsList
            ),
            productDemandsListCtx: formatTableCTX(res.data.productDemandsList),
            // productDemandsListHead: [],
            // productDemandsListCtx: []
          };
          
          const fabricList = this.info.fabricList || [];
          const pieceList = this.info.pieceList || [];
          const sizeItemList = this.info.sizeItemList || [];
          const detailItemList = this.info.detailItemList || [];
          const productDemandsListCtx = this.info.productDemandsListCtx || [];
          if (this.isWoollen === true) {
            setData(fabricList, 3);
          } else {
            // 面料详情
            setData(fabricList, 7);
          }

          // 裁片
          setData(pieceList, 18);

          // 特殊工艺
          setData(sizeItemList, 25);

          // 工艺做法
          setData(detailItemList, 3);

          setColor(this.info.productDemandsListHead, productDemandsListCtx, 10);

          function setData(array, max) {
            if (array.length < max) {
              const length = array.length;
              for (let i = 0; i < max - length; i++) {
                array.push({ sizeMap: {} });
              }
            } else {
              array.length = max;
            }
          }

          function setColor(arrayHead, arrayCTX, max) {
            if (arrayHead.length > 0) {
              const array = [];
              for (let i = 0; i < arrayHead.length; i++) {
                array.push("");
              }
              for (let i = 0; i < max - arrayCTX.length; i++) {
                arrayCTX.push(array);
              }
            } else {
              for (let i = 0; i < max - arrayCTX.length + 3; i++) {
                arrayCTX.push([""]);
              }
            }
          }
          console.log(this.info);
        })
        .fail(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
.productionProcess-print {
  $_normal_font: 4mm;
  $_title_font: 5mm;
  $box_width: 190mm;
  $box_height: 277mm;
  $_black: #333;
  div,
  td {
    font-size: 12px;
  }
  .default_text_over {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    overflow: hidden;
  }
  .default_border {
    border-top: 1px solid $_black;
    border-left: 1px solid $_black;
  }
  .default_title {
    height: 6mm;
    text-align: center;
  }
  .default_table {
    width: 100%;
    td {
      border-collapse: collapse;
    }
    td,
    th {
      border: 1px solid $_black;
      border: 1px solid $_black;
    }
  }
  .body-table__foot {
    height: 5mm;
    @include flex_center(space-around, center);
    border-left: 1px solid $_black;
    border-right: 1px solid $_black;
    border-bottom: 1px solid $_black;
  }
  // 第一页
  .productionProcess-print__page {
    margin: 0 auto;
    width: $box_width;
    // height: $box_height;
  }

  // 内容部分
  // 210mm 297mm
  .productionProcess-print__body {
    &.page1 {
      @include grid_template($box_width, 100mm 150mm);
      margin: 0 auto;
      width: $box_width;
      & > .body-info {
        @include grid_template(90mm $box_width - 90mm, 100mm);
        & > .body-info__left {
          @include grid_template(100%, 44mm calc(100% - 44mm));
        }
        & > .body-info__right {
          @include grid_template(100%, calc(100% - 48mm) 48mm);
        }
      }
    }

    &.page2 {
      @include grid_template($box_width, 140mm 80mm 30mm);
      margin: 0 auto;
      width: $box_width;
    }
  }

  // 前后款式图
  .body-material-img {
    & > .body-material-img__title {
      @extend .default_title;
    }
    .body-material-img__img {
      padding: 2px;
      @include flex_center();
      img {
        height: 100%;
        max-width: 100%;
      }
      height: calc(100% - 6mm);
    }
    & > div {
      @extend .default_border;
    }
  }

  // 工艺做法
  .productionProcess-special {
    border-right: 1px solid $_black;
    .productionProcess-special__head {
      height: 6mm;
      text-align: left;
      @extend .default_border;
    }

    .productionProcess-special__body {
      display: flex;
      height: calc(100% - 6mm);
      .productionProcess-special__item {
        .item-head,
        .item-img,
        .item-desc > p {
          @extend .default_border;
          @extend .default_text_over;
        }
        .item-img {
          padding: 2px;
          @include flex_center();
        }
        .item-desc > p:nth-child(2) {
          border-top: none;
        }
        flex: 1;
        @include grid_template(100%, 5% 35% 60%);
        img {
          height: 100%;
          max-width: 100%;
        }
        .item-desc {
          @include grid_template(100%, 10% 90%);
        }
      }
    }
  }

  // 其他说明
  .productionProcess-other {
    border-right: 1px solid $_black;
    .productionProcess-special__head {
      @extend .default_border;
      height: 6mm;
      text-align: left;
    }
    .productionProcess-other__table {
      @include grid_template(100%, 10% 15% 15% 15% 15% 15% 15%);
      height: calc(100% - 6mm);
      & > .table__head {
        & > div {
          @extend .default_border;
        }
        text-align: center;
        @include grid_template(30% 70%, 100%);
      }
      & > .table__body {
        & > div {
          @extend .default_border;
        }
        @include grid_template(30% 70%, 100%);
        div:first-child {
          text-align: center;
        }
      }
    }
  }

  // 特殊工艺
  .productionProcess-teshu {
    border-right: 1px solid $_black;
    border-left: 1px solid $_black;
    .productionProcess-teshu__head {
      @extend .default_border;
      height: 6mm;
      text-align: left;
    }
    .productionProcess-teshu__body {
      border-bottom: 1px solid $_black;
      & > .teshu-body__left {
        padding: 2px;
        @include flex_center();
        img {
          height: 100%;
          max-width: 100%;
        }
        @extend .default_border;
      }
      height: calc(100% - 6mm);
      @include grid_template(30% 70%, 100%);
    }
    .teshu-body__right {
      & > .teshu-body__right__head > div,
      & > .teshu-body__right__body {
        @extend .default_border;
        word-wrap: break-word;
      }

      @include grid_template(100%, 20% 80%);
    }
    .teshu-body__right__head {
      @include grid_template(50% 50%, 100%);
    }
  }
}
</style>

<style lang="scss">
@media print {
  .productionProcess-print__page {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
  }
}
</style>
